import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  // 登录页
  {
    path: '/',
    component: () => import('../views/MainPage.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/mainPage',
    name: 'mainPage',
    component: () => import('../views/MainPage.vue')
  },
  {
    path: '/testPage',
    name: 'testPage',
    component: () => import('../views/TestPage.vue')
  }
 
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// router.beforeEach((to, from, next) => {  
//   // 验证token，只有存在token时才能跳转到内容页  
//   const token = sessionStorage.getItem('token')  
//   if (!token && to.path !== '/login') { 
//     next('/login')
//   } else {  
//     next()  
//   }  
// }) 

export default router
